import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { ExpirationStatusDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-expirationstatus-container',
  templateUrl: './expirationstatus-container.component.html',
  styleUrls: ['./expirationstatus-container.component.scss']
})
export class ExpirationStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  expirationstatuss$: Observable<ExpirationStatusDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("ExpirationStatus");
    this.expirationstatuss$ = this.gatwayFacade.loadGateway("ExpirationStatus");
    this.expirationstatuss$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteExpirationStatus(deletedValue: any) {
    this.gatwayFacade.remove("ExpirationStatus", deletedValue);
    // this.store.dispatch(ExpirationStatusStoreActions.removeExpirationStatus({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitExpirationStatus(formValue: any) {
    console.log("form value: ", formValue);
    formValue.ExpirationStatuss = formValue.ExpirationStatuss.reverse();
    event.preventDefault();
    const pullData = formValue.ExpirationStatuss;
    //const newPullData = formValue.ExpirationStatuses;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllExpirationStatus = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllExpirationStatus.push(pullData[i]);
    }
  }

// check if the addAllExpirationStatus array is not empty, then dispatch the data to the store
   if(addAllExpirationStatus.length !== 0) {
    this.gatwayFacade.add('ExpirationStatus', addAllExpirationStatus);
    // this.store.dispatch(ExpirationStatusStoreActions.addExpirationStatus({newExpirationStatus: addAllExpirationStatus}));

   }

// dispatch update data to the store
this.gatwayFacade.update('ExpirationStatus', allUpdates, ['id']);
    // this.store.dispatch(ExpirationStatusStoreActions.updateExpirationStatus({updateExpirationStatus: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



